export default {
  en: {
    title: 'Auto-suggest',
    modal: {
      heading: 'Speed up filling out your profile with auto-suggested answers',
      body: 'Upload previous assessments & documentation and we will help auto suggest answers.',
      li1: 'You can review and edit any suggestions',
      li2: 'Your data will never leave Risk Ledger',
      li3: 'Previous assessments will never be shown to clients',
      cancel: 'Not now',
      cta: 'Try it out',
    },
    sidePanel: {
      heading: 'Upload previous assessments and documents and receive auto-suggested answers',
      text: 'You can review and edit any of the suggestions, staying in control of what you submit.',
      prevAssessmentsTitle: 'Previous assessments',
      prevAssessmentsHelpText:
        'Upload previous security questionnaires and frameworks that your business has completed to generate answer suggestions. Examples include previous RFPs, SIG, CAIQ, and ISO27001/SOC2 reports.',
      prevAssessmentsSubtitle: 'These will be {hiddenOrVisible} from your clients',
      hidden: 'hidden',
      visible: 'visible',
      evidenceTitle: 'Documents and certifications',
      evidenceHelpText:
        'Upload your policies and other documents to improve the quality of the answer suggestions. Uploaded documents can be used as supporting evidence for your answers in the assessment.',
      noPreviousAssessments: 'No previous assessments uploaded',
      noDocuments: 'No documents uploaded',
      cta: 'Suggest answers',
      maxRuns: 'You reached the auto-suggest limit',
      maxRunsText: 'Contact support to increase your limit',
      noDocsTooltip: "You haven't added any documents",
      noNewDocsTooltip: "You haven't added any new documents",
      maxRunsTooltip: "You've exceeded the max number of auto-suggest runs",
    },
  },
};
